import { useUser } from "@clerk/react";
import { usePlans } from "@clerk/react/experimental";
import { useMemo } from "react";

import { useResolvedHas } from "~/feature/subscription/hooks/useResolvedHas";
import { FeatureKey } from "~/types/subscription";

const planNameOverrides: Partial<Record<FeatureKey, string>> = {
  [FeatureKey.APY_FILTER]: "Standard",
  [FeatureKey.ROI_FILTER]: "Standard",
};

export const useSubscriptionGuard = (featureKey: FeatureKey) => {
  const { user } = useUser();
  const { data } = usePlans();
  const { hasFeature } = useResolvedHas();

  const isLocked = useMemo(
    () => !user || !hasFeature(featureKey),
    [featureKey, hasFeature, user]
  );

  const availableOnPlan = useMemo(() => {
    if (planNameOverrides[featureKey]) return planNameOverrides[featureKey];
    const plan =
      data?.find((plan) =>
        plan.features.some((item) => item.slug === featureKey)
      )?.name || "Highest";
    return plan;
  }, [data, featureKey]);

  return { isLocked, availableOnPlan };
};
